export const OPTIONS = [
    { nombre: 'Usuarios', path: 'usuarios', logo: 'group' },
    { nombre: 'Clientes', path: 'clientes', logo: 'dataset' },
    { nombre: 'Carga CSV', path: 'cargaMasiva', logo: 'pending' },
    { nombre: 'Campañas', path: 'campaña', logo: 'redeem' },
    { nombre: 'Términos', path: 'manageAPTC', logo: 'description' },
    { nombre: 'Cerrar Sesión', path: 'login', logo: 'close' },
]
